import React from 'react';
import SiteCharts from '../../../components/SiteCharts';
import { erabDropRateChartConfig } from '../chartConfigs';

/**
 * Props for the ErabDropRateEcharts component
 */
interface ErabDropRateEchartsProps {
  /** Callback function to toggle fullscreen mode */
  onFullscreenToggle: () => void;
  /** Current fullscreen state */
  isFullscreen: boolean;
}

/**
 * ERAB Drop Rate Chart (LTE Site Level)
 * 
 * Displays E-UTRAN Radio Access Bearer (ERAB) drop rate metrics across all cells:
 * - Number of ERAB Drops (count)
 * - ERAB Drop Rate (percentage)
 * 
 * @component
 * @see {@link ../chartConfigs.ts} - Chart configuration (erabDropRateChartConfig)
 * @see API: /api/lte/erab-drop-rate?site_name={siteName}
 */

const ErabDropRateEcharts: React.FC<ErabDropRateEchartsProps> = ({ 
  onFullscreenToggle, 
  isFullscreen 
}) => {
  return (
    <SiteCharts 
      config={erabDropRateChartConfig}
      onFullscreenToggle={onFullscreenToggle}
      isFullscreen={isFullscreen}
    />
  );
};

export default ErabDropRateEcharts;
